import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LandingPage.css";

const PrivacyPolicy = () => {
  return (
    <>
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/css/bootstrap.min.css"
        rel="stylesheet"
      />
      
      <div className="landing-page">
        {/* Privacy Policy Content Section */}
        <section className="how-it-works" style={{ paddingTop: "120px" }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className="section-title">Privacy Policy</h2>
                <p className="section-subtitle">
                  Last updated: September 12, 2025
                </p>
              </div>
            </div>
            
            <div className="row">
              <div className="col-12">
                <div style={{ textAlign: "left", maxWidth: "800px", margin: "0 auto" }}>
                  
                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>1) Overview</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    This Privacy Policy explains how <strong>Rite Innovations LLC</strong> (doing business as "Rite Soccer") 
                    collects, uses, and shares information when you visit our website or join our waitlist.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>2) Information We Collect</h3>
                  <ul style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6", paddingLeft: "20px" }}>
                    <li><strong>Contact information:</strong> email address and, if provided, your name.</li>
                    <li><strong>Optional details:</strong> role (player/coach/scout/club/fan/creator), country/region, city, social handle, and links you choose to share (e.g., clips).</li>
                    <li><strong>Technical data:</strong> IP address, device and browser type, pages viewed, referral source, and approximate location.</li>
                    <li><strong>Cookies & similar technologies:</strong> we may use cookies and analytics tools to understand site usage and improve performance.</li>
                  </ul>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>3) How We Use Information</h3>
                  <ul style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6", paddingLeft: "20px" }}>
                    <li>To operate, maintain, and improve the site.</li>
                    <li>To manage the waitlist and send updates, announcements, and marketing (you may opt out at any time).</li>
                    <li>To personalize basic communications (e.g., segmenting by role or region).</li>
                    <li>To prevent fraud, abuse, or violations of our Terms.</li>
                    <li>To comply with legal obligations.</li>
                  </ul>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>4) Legal Bases (EEA/UK users)</h3>
                  <p style={{ marginBottom: "15px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    Where GDPR or equivalent laws apply, we process personal data based on:
                  </p>
                  <ul style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6", paddingLeft: "20px" }}>
                    <li><strong>Consent</strong> (e.g., for marketing emails or optional fields you submit; <strong>for 13–15-year-old users, with parent/guardian consent where required</strong>).</li>
                    <li><strong>Legitimate interests</strong> (e.g., site security, analytics, service improvement).</li>
                    <li><strong>Contract</strong> (e.g., providing requested updates via the waitlist).</li>
                  </ul>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>5) Sharing of Information</h3>
                  <p style={{ marginBottom: "15px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    We may share information with:
                  </p>
                  <ul style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6", paddingLeft: "20px" }}>
                    <li><strong>Service providers</strong> (e.g., email tools, analytics, hosting, security, customer support) who process data on our behalf under contract.</li>
                    <li><strong>Legal authorities</strong> if required by law, regulation, or legal process.</li>
                    <li><strong>Business transferees</strong> in connection with a merger, acquisition, or asset sale.</li>
                  </ul>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>6) International Transfers</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    Your information may be transferred to the <strong>United States</strong> and other countries with different 
                    data-protection laws. Where required, we use appropriate safeguards for such transfers.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>7) Data Retention</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    We keep personal data only as long as necessary for the purposes described above or as required 
                    by law, then delete or anonymize it.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>8) Your Choices & Rights</h3>
                  <ul style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6", paddingLeft: "20px" }}>
                    <li><strong>Emails:</strong> You can unsubscribe from marketing emails using the link in any message.</li>
                    <li><strong>Cookies:</strong> You can manage cookies in your browser settings; some site features may not function without cookies.</li>
                    <li><strong>Access/Correction/Deletion:</strong> Depending on your jurisdiction (e.g., <strong>EEA/UK GDPR, California CCPA/CPRA</strong>), you may have rights to request access to, correction of, deletion of, or portability of your personal data, and to object to or restrict certain processing. To make a request, email <a href="mailto:info@ritesoccer.com" style={{ color: "#005214", textDecoration: "none" }}>info@ritesoccer.com</a>. We will verify and respond as required by applicable law.</li>
                    <li><strong>Non-discrimination (California):</strong> We will not discriminate against you for exercising privacy rights available under law.</li>
                  </ul>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>9) Children's Privacy</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    Our site is <strong>not directed to children under 13</strong>, and we do not knowingly collect information 
                    from them. Individuals aged <strong>13–15</strong> may join the waitlist <strong>only with verifiable parent or legal 
                    guardian consent</strong>. If we learn that a child under 13 submitted information—or that 13–15 
                    information was collected without required consent—we will delete it. To request deletion, 
                    contact <a href="mailto:info@ritesoccer.com" style={{ color: "#005214", textDecoration: "none" }}>info@ritesoccer.com</a>.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>10) Security</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    We use reasonable administrative, technical, and physical safeguards to protect information. 
                    However, no method of transmission or storage is 100% secure.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>11) Changes</h3>
                  <p style={{ marginBottom: "30px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    We may update this Privacy Policy from time to time. The "Last updated" date reflects the latest 
                    version. Material changes will be posted here.
                  </p>

                  <h3 style={{ color: "#000", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>12) Contact</h3>
                  <p style={{ marginBottom: "50px", color: "#000", fontSize: "16px", lineHeight: "1.6" }}>
                    Email: <a href="mailto:info@ritesoccer.com" style={{ color: "#005214", textDecoration: "none" }}>info@ritesoccer.com</a>
                  </p>

                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer" id="footer-contact">
          <div className="container">
            <div className="text-center">
              <img
                src="./assets/footer-logo.png"
                alt="Rite Soccer Logo"
                className="mb-3 footer-logo"
              />

              <h2>Let's connect</h2>

              <p>
                Say hello by email for inquiries, support, partnerships or
                promotion <br></br>
                (
                <a href="mailto:info@ritesoccer.com">info@ritesoccer.com</a>)
              </p>
              <div className="col-12 text-center mb-4">
                <p className="mb-0 address">
                  <img src="./assets/map.png" style={{ width: '14px' }} />35 Payne Street, Quincy MA.
                </p>
              </div>

              {/* Social Icons Row */}
              <div className="row justify-content-center g-3 social-icons">
                <div className="col-auto">
                  <a href="#">
                    <img src="./assets/x-icon.png" alt="X" />
                  </a>
                </div>
                <div className="col-auto">
                  <a href="#">
                    <img src="./assets/instagram-icon.png" alt="Instagram" />
                  </a>
                </div>
                <div className="col-auto">
                  <a href="#">
                    <img src="./assets/tiktok-icon.png" alt="TikTok" />
                  </a>
                </div>
              </div>
            </div>

            <div className="row copy-right">
              <div className="col-6 text-start">
                <p className="mb-0 c1">
                  © 2024 Rite Soccer. All rights reserved.
                </p>
              </div>
              <div
                className="col-6 text-end"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                  justifyContent: "flex-end",
                }}
              > 
                <Link to="/terms" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  terms & conditions
                </Link>
                <Link to="/privacy" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  privacy policy
                </Link>
              </div>
            </div>

            <div className="copy-right-mob">
              <div className="col-mob text-center">
                <p className="mb-0 c1">
                  © 2024 Rite Soccer. All rights reserved.
                </p>
              </div>
              <div
                className="col-12 text-end"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                  justifyContent: "center",
                }}
              >
                <Link to="/terms" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  terms & conditions
                </Link>
                <Link to="/privacy" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
                  privacy policy
                </Link>
              </div>
            </div>

          </div>
        </footer>
      </div>

      <script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/js/bootstrap.bundle.min.js"></script>
    </>
  );
};

export default PrivacyPolicy;